import React from "react";
import { useSelector } from "react-redux";
import StaffOnboarding from "./onboarding/StaffOnboarding";
import StaffPrincipal from "./principal/StaffPrincipal";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";

const Classes = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_onboarding) {
      return <StaffOnboarding />;
    }
    if (state.auth.user.is_principal) {
      return <StaffPrincipal />;
    }
    return <PermissionDenied />;
  }
};

export default Classes;
